import RatioIcon1 from '../../assets/svg/1-1.svg?react';
import RatioIcon6 from '../../assets/svg/9-16.svg?react';
import RatioIcon7 from '../../assets/svg/16-9.svg?react';
import FJTextToFullVideoIcon from '../../assets/svg/textToVideo/text-to-full-video.svg?react';
import FJBlogUrlToVideoIcon from '../../assets/svg/textToVideo/blog-url-to-video.svg?react';
import FJProductUrlToAdsIcon from '../../assets/svg/textToVideo/product-url-to-ads.svg?react';
import FJPptToVideoIcon from '../../assets/svg/textToVideo/ppt-to-video.svg?react';
import FJAmazonIcon from '../../assets/svg/textToVideo/amazon.svg?react';
// import FJShopifyIcon from '../../assets/svg/textToVideo/shopify.svg?react';
import FJEbayIcon from '../../assets/svg/textToVideo/ebay.svg?react';
import FJConstant from '../../constants/FJConstant';
import FJAppConstant from '../../constants/FJAppConstant';
import FJConfig from '../FJConfig';
import FJTextToVideoConfig from '../appConfig/FJTextToVideoConfig';
export const PRODUCT_URL_TO_VIDEO_MAX_IMAGE_NUM = 30;
export const MAN_SCENE_NUM = 50;
export const MAX_SCRIPT_LENGTH = 5000;
export const MAX_SCENE_TEXT_LENGTH = 500;
export const MAX_PRODUCT_NAME_LENGTH = 1000;
export const MAX_PRODUCT_DESCRIPTION_LENGTH = 5000;
export const MAX_PPT_FILE_SIZE = 50 * 1024 * 1024; // 50MB
export const TEXT_TO_VIDEO_PRICE = {
    textToScript: 0.5, //0.5积分/次
    analysisUrl: 0.5, //0.5积分/次
    textToImage: 1, //1积分/张
    mediaMatch: 2, //2积分/次
    textToSpeech: 320, //1积分320字符
    textToFullVideo: 0, //不额外收取积分
    blogUrlToVideo: 0, //2积分/次
    productUrlToVideo: 2, //不额外收取积分
    pptToVideo: 2, //2积分/次
};
// 免费类型
export const TEXT_TO_VIDEO_DEDUCT_ENUM_TYPE = {
    TEXT_TO_SCRIPT: 'text-to-script',
    ANALYSIS_URL: 'analysis-url',
    TEXT_TO_FULL_VIDEO: 'text-to-full-video',
    PRODUCT_URL_TO_VIDEO: 'product-url-to-video',
    BLOG_URL_TO_VIDEO: 'blog-url-to-video',
    PPT_TO_VIDEO: 'ppt-to-video',
};
export const TEXT_TO_IMAGE_STYLE_LIST = [
    // 屏蔽
    // {
    //     value: '照片风格',
    //     name: 'photo-series',
    //     previewImg: 'photo-series.png',
    //     type: 'chrome',
    // },
    // {
    //     value: '动画风格',
    //     name: 'anime-series',
    //     previewImg: 'anime-series.png',
    //     type: 'chrome',
    // },
    {
        value: 'photo-realistic, photography,4k, highly detailed',
        name: 'photo',
        previewImg: 'photo.png',
    },
    {
        value: 'cinematic, cinematic lighting, ultra-detailed, film, 8k',
        name: 'cinematic',
        previewImg: 'cinematic.png',
    },
    {
        value: 'solid background photo studio, studio lights, photography,',
        name: 'studio-shot',
        previewImg: 'studio-shot.png',
    },

    {
        value: 'illustration, vector',
        name: 'vector',
        previewImg: 'vector.png',
    },
    {
        value: '3d blender render',
        name: 'text-to-image-3d',
        previewImg: '3d.png',
    },
    {
        value: 'japanese animation style',
        name: 'text-to-image-anime',
        previewImg: 'anime.png',
    },
    {
        value: 'anime cartoon style',
        name: 'cartoon',
        previewImg: 'cartoon.png',
    },
    {
        value: '3D cartoon',
        name: '3d-cartoon',
        previewImg: '3d-cartoon.png',
    },

    {
        value: 'Futuristic Anime, Sci Fi Art',
        name: 'sci-fi-anime',
        previewImg: 'sci-fi-anime.png',
    },

    {
        value: 'watercolor style, watercolor painting, illustration, pastel color',
        name: 'watercolor',
        previewImg: 'watercolor.png',
    },
    {
        value: 'pencil sketch, expressive line-work, high detail, high-resolution',
        name: 'sketch',
        previewImg: 'sketch.png',
    },
    {
        value: 'comic art, 1940s–1950s, Retro comic style artwork',
        name: 'retro-comic',
        previewImg: 'retro-comic.png',
    },
];

export const TEXT_TO_VIDEO_RATIO_LIST = [
    {
        name: '16:9',
        value: 16 / 9,
        icon: RatioIcon7,
        ratioValue: 'landscape',
        editRatio: ['RATIO_LANDSCAPE', 'RATIO_CINEMATIC'],
    },
    {
        name: '1:1',
        value: 1,
        icon: RatioIcon1,
        ratioValue: 'square',
        editRatio: ['RATIO_SQUARE', 'RATIO_SOCIAL'],
    },
    {
        name: '9:16',
        value: 9 / 16,
        icon: RatioIcon6,
        ratioValue: 'vertical',
        editRatio: 'RATIO_VERTICAL',
    },
];
export const MEDIA_SOURCE_LIST = [
    {
        value: FJConstant.AI_GENERATED,
        name: 'ai-image',
    },
    {
        value: FJConstant.STOCK_LIBRARY,
        name: 'stock-library',
    },
];
export const STOCK_TYPE_LIST = [
    {
        value: FJConstant.IMAGE_AND_VIDEO_MIXING,
        name: 'image-and-video-mixing',
    },
    {
        value: FJConstant.IMAGE,
        name: 'image',
    },
    {
        value: FJConstant.VIDEO,
        name: 'video',
    },
];
export const SUBTITLE_STYLE_LIST = [
    {
        id: 'black-bar',
        text: 'black-bar',
        imgUrl: FJConfig.staticResourceServe + FJTextToVideoConfig.subtitleStylePath + '/black-bar/black-bar.jpg',
        jsonUrl: FJConfig.staticResourceServe + FJTextToVideoConfig.subtitleStylePath + '/black-bar/black-bar.json',
    },
    {
        id: 'white-bar',
        text: 'white-bar',
        imgUrl: FJConfig.staticResourceServe + FJTextToVideoConfig.subtitleStylePath + '/white-bar/white-bar.jpg',
        jsonUrl: FJConfig.staticResourceServe + FJTextToVideoConfig.subtitleStylePath + '/white-bar/white-bar.json',
    },
    {
        id: 'border',
        text: 'border',
        imgUrl: FJConfig.staticResourceServe + FJTextToVideoConfig.subtitleStylePath + '/border/border.jpg',
        jsonUrl: FJConfig.staticResourceServe + FJTextToVideoConfig.subtitleStylePath + '/border/border.json',
    },
    {
        id: 'highlight',
        text: 'highlight',
        imgUrl: FJConfig.staticResourceServe + FJTextToVideoConfig.subtitleStylePath + '/highlight/highlight.jpg',
        jsonUrl: FJConfig.staticResourceServe + FJTextToVideoConfig.subtitleStylePath + '/highlight/highlight.json',
        videoUrl: FJConfig.staticResourceServe + FJTextToVideoConfig.subtitleStylePath + '/highlight/highlight.webm',
    },
    {
        id: 'block',
        text: 'block',
        imgUrl: FJConfig.staticResourceServe + FJTextToVideoConfig.subtitleStylePath + '/block/block.jpg',
        jsonUrl: FJConfig.staticResourceServe + FJTextToVideoConfig.subtitleStylePath + '/block/block.json',
        videoUrl: FJConfig.staticResourceServe + FJTextToVideoConfig.subtitleStylePath + '/block/block.webm',
    },
    {
        id: 'translucent',
        text: 'translucent',
        imgUrl: FJConfig.staticResourceServe + FJTextToVideoConfig.subtitleStylePath + '/translucent/translucent.jpg',
        jsonUrl: FJConfig.staticResourceServe + FJTextToVideoConfig.subtitleStylePath + '/translucent/translucent.json',
        videoUrl:
            FJConfig.staticResourceServe + FJTextToVideoConfig.subtitleStylePath + '/translucent/translucent.webm',
    },
    {
        id: 'dark',
        text: 'dark',
        imgUrl: FJConfig.staticResourceServe + FJTextToVideoConfig.subtitleStylePath + '/dark/dark.jpg',
        jsonUrl: FJConfig.staticResourceServe + FJTextToVideoConfig.subtitleStylePath + '/dark/dark.json',
        videoUrl: FJConfig.staticResourceServe + FJTextToVideoConfig.subtitleStylePath + '/dark/dark.webm',
    },
    {
        id: 'fresh',
        text: 'fresh',
        imgUrl: FJConfig.staticResourceServe + FJTextToVideoConfig.subtitleStylePath + '/fresh/fresh.jpg',
        jsonUrl: FJConfig.staticResourceServe + FJTextToVideoConfig.subtitleStylePath + '/fresh/fresh.json',
        videoUrl: FJConfig.staticResourceServe + FJTextToVideoConfig.subtitleStylePath + '/fresh/fresh.webm',
    },
    {
        id: 'white-bar-highlight',
        text: 'white-bar-highlight',
        imgUrl:
            FJConfig.staticResourceServe +
            FJTextToVideoConfig.subtitleStylePath +
            '/white-bar-highlight/white-bar-highlight.jpg',
        jsonUrl:
            FJConfig.staticResourceServe +
            FJTextToVideoConfig.subtitleStylePath +
            '/white-bar-highlight/white-bar-highlight.json',
        videoUrl:
            FJConfig.staticResourceServe +
            FJTextToVideoConfig.subtitleStylePath +
            '/white-bar-highlight/white-bar-highlight.webm',
    },
    {
        id: 'bright',
        text: 'bright',
        imgUrl: FJConfig.staticResourceServe + FJTextToVideoConfig.subtitleStylePath + '/bright/bright.jpg',
        jsonUrl: FJConfig.staticResourceServe + FJTextToVideoConfig.subtitleStylePath + '/bright/bright.json',
        videoUrl: FJConfig.staticResourceServe + FJTextToVideoConfig.subtitleStylePath + '/bright/bright.webm',
    },
    {
        id: 'slant',
        text: 'slant',
        imgUrl: FJConfig.staticResourceServe + FJTextToVideoConfig.subtitleStylePath + '/slant/slant.jpg',
        jsonUrl: FJConfig.staticResourceServe + FJTextToVideoConfig.subtitleStylePath + '/slant/slant.json',
        videoUrl: FJConfig.staticResourceServe + FJTextToVideoConfig.subtitleStylePath + '/slant/slant.webm',
    },
    {
        id: 'shadowed-block',
        text: 'shadowed-block',
        imgUrl:
            FJConfig.staticResourceServe + FJTextToVideoConfig.subtitleStylePath + '/shadowed-block/shadowed-block.jpg',
        jsonUrl:
            FJConfig.staticResourceServe +
            FJTextToVideoConfig.subtitleStylePath +
            '/shadowed-block/shadowed-block.json',
        videoUrl:
            FJConfig.staticResourceServe +
            FJTextToVideoConfig.subtitleStylePath +
            '/shadowed-block/shadowed-block.webm',
    },
    {
        id: 'spotlight',
        text: 'spotlight',
        imgUrl: FJConfig.staticResourceServe + FJTextToVideoConfig.subtitleStylePath + '/spotlight/spotlight.jpg',
        jsonUrl: FJConfig.staticResourceServe + FJTextToVideoConfig.subtitleStylePath + '/spotlight/spotlight.json',
        videoUrl: FJConfig.staticResourceServe + FJTextToVideoConfig.subtitleStylePath + '/spotlight/spotlight.webm',
    },
    {
        id: 'white-border',
        text: 'white-border',
        imgUrl: FJConfig.staticResourceServe + FJTextToVideoConfig.subtitleStylePath + '/white-border/white-border.jpg',
        jsonUrl:
            FJConfig.staticResourceServe + FJTextToVideoConfig.subtitleStylePath + '/white-border/white-border.json',
        videoUrl:
            FJConfig.staticResourceServe + FJTextToVideoConfig.subtitleStylePath + '/white-border/white-border.webm',
    },
    {
        id: 'hollow',
        text: 'hollow',
        imgUrl: FJConfig.staticResourceServe + FJTextToVideoConfig.subtitleStylePath + '/hollow/hollow.jpg',
        jsonUrl: FJConfig.staticResourceServe + FJTextToVideoConfig.subtitleStylePath + '/hollow/hollow.json',
        videoUrl: FJConfig.staticResourceServe + FJTextToVideoConfig.subtitleStylePath + '/hollow/hollow.webm',
    },
    {
        id: 'neon',
        text: 'neon',
        imgUrl: FJConfig.staticResourceServe + FJTextToVideoConfig.subtitleStylePath + '/neon/neon.jpg',
        jsonUrl: FJConfig.staticResourceServe + FJTextToVideoConfig.subtitleStylePath + '/neon/neon.json',
        videoUrl: FJConfig.staticResourceServe + FJTextToVideoConfig.subtitleStylePath + '/neon/neon.webm',
    },
    {
        id: 'shadow',
        text: 'shadow',
        imgUrl: FJConfig.staticResourceServe + FJTextToVideoConfig.subtitleStylePath + '/shadow/shadow.jpg',
        jsonUrl: FJConfig.staticResourceServe + FJTextToVideoConfig.subtitleStylePath + '/shadow/shadow.json',
        videoUrl: FJConfig.staticResourceServe + FJTextToVideoConfig.subtitleStylePath + '/shadow/shadow.webm',
    },
];
export const TEXT_TO_VIDEO_STEP_LIST = [
    {
        type: FJConstant.STEP_TYPE_HOME,
        name: 'home',
    },
    {
        type: FJConstant.STEP_TYPE_SCRIPTS_PASTE,
        name: 'enter-script',
    },
    {
        type: FJConstant.STEP_TYPE_SCRIPTS_EDIT,
        name: 'edit-script',
    },
    {
        type: FJConstant.STEP_TYPE_VIDEO_SETTINGS,
        name: 'settings',
    },
];

export const TEXT_TO_VIDEO_TAB_LIST = [
    {
        name: 'text-to-full-video',
        value: FJAppConstant.TEXT_TO_FULL_VIDEO,
        icon: FJTextToFullVideoIcon,
    },
    {
        name: 'blog-url-to-video',
        value: FJAppConstant.BLOG_URL_TO_VIDEO,
        icon: FJBlogUrlToVideoIcon,
    },
    {
        name: 'product-url-to-video',
        value: FJAppConstant.PRODUCT_URL_TO_VIDEO,
        icon: FJProductUrlToAdsIcon,
    },
    {
        name: 'ppt-to-video',
        value: FJAppConstant.PPT_TO_VIDEO,
        icon: FJPptToVideoIcon,
    },
];
export const TEXT_TO_VIDEO_TEMPLATE_LIST = [
    {
        templateName: 'knowledge-sharing',
        text: 'knowledge-sharing-desc',
        placeholder: 'the-knowledge-you-want-to-share',
        options: [
            [
                'professional-and-rigorous',
                'relaxed-and-humorous',
                'easy-to-understand',
                'encouraging',
                'inspiring',
                'storytelling',
                'friendly-and-interactive',
            ],
        ],
        result: 'Generate a video about introducing (the knowledge you want to share), list the key content, reveal the principles behind it, and explain it in (professional and rigorous) style.',
    },
    {
        templateName: 'business-marketing',
        text: 'business-marketing-desc',
        placeholder: 'product-name-company-name-etc',
        options: [
            ['product-demo', 'social-media', 'new-product-launch', 'product-ad', 'company-promo'],
            [
                'emotional-resonance',
                'function-guide',
                'call-to-action',

                'storytelling',
                'comparison',
                'customer-recommendation',
                'life-scenario',
                'time-urgency',
            ],
        ],
        result: 'Generate a video about introducing (product name, company name, etc.) for (social media), highlight the core features and display in a (function guide) way.',
    },
    {
        templateName: 'story',
        text: 'story-desc',
        placeholder: 'the-theme-of-the-story',
        options: [
            [
                'first-person',
                'narration',
                'dialogue',
                'reversal',
                'emotion-driven',
                'visualization',
                'flashback',
                'easiness-and-humor',
            ],
        ],
        result: 'Generate a story video about (the theme of the story), explain it through narration, and include the climax and ending.',
    },
    {
        templateName: 'life',
        text: 'life-desc',
        placeholder: 'your-daily-life-and-experiences',
        options: [['reality', 'emotion', 'humor', 'storytelling', 'inspiration', 'life-tips', 'exploration']],
        result: 'Generate a video about sharing (your daily life and experiences), present the experiences and feelings in reality style.',
    },
];
export const LANGUAGE_WORDS_PER_MINUTE = {
    'zh-Hans': 240,
    'zh-Hant': 240,
    ja: 90,
    en: 800,
    de: 900,
    fr: 900,
    'fr-ca': 900,
    pt: 900,
    'pt-pt': 900,
    es: 900,
    ar: 400,
};
export const PRODUCT_SUPPORT_LIST = [
    {
        icon: FJAmazonIcon,
        name: 'amazon',
    },
    // {
    //     icon: FJShopifyIcon,
    //     name: 'shopify',
    // },
    {
        icon: FJEbayIcon,
        name: 'ebay',
    },
];
export const PRODUCT_URL_EXAMPLE_LIST = [
    `https://www.amazon.com/fire-tv-stick-with-3rd-gen-alexa-voice-remote/dp/B08C1W5N87/ref=sr_1_1?crid=31W7AIPUFMG4B&dib=eyJ2IjoiMSJ9.TwXZOB5zEgdgSXI3aCxzhjABTv0EtjwQc9G1wUWFuPLiyIj13aEZTGGuCDHoAB8gyKF6LFAcYlwRQjfR-yLHjrg9wcGl_JaWtjXrtzSaeZI6gNKUpwlaVzuw_AsSGNdZ85Xk00Dzl5KVZQj2l8w5f3uMEZhl0E924CS8IhHY9dzhKHv3yJ1n3TepAUa_muz6xWjjtZCmSSoZjCJt2QTA4QvF2k8Iyfe4sn_vZE7mikc.pnB24JiIdMqFYQB1iEtXv19ca4lLWnQK2sBnrw79c6Q&dib_tag=se&keywords=fire+stick&qid=1742440196&sprefix=fire%2Caps%2C710&sr=8-1`,
    `https://www.amazon.com/Amazon-eGift-Card-Logo-Animated/dp/B07PCMWTSG/ref=sr_1_1?crid=3F8CMXTDM2AM4&dib=eyJ2IjoiMSJ9.7EE9qWewdvNuR5vM13QjXU8tmdh_5jz9M3_IjCjj6k35zH6l1wFovGsJ2UqIQjnLgkF7jkzUP3PJTvu-kfepA21xsKWXRzLRxxtiwDzA8XgnXAGopn-fIUUagicBGPQx0-dykqKAVDRxG_WZaHe9MSwhFmESjwpOY25_UzGEfNBWIOv8y5-kiRGNrjYMLFr46ct-foCmRpieGhciCc4Z5efoYdevSTm0UdmnJYGKZ9nnzI4EJ-w_ixiYw138CXSxOHE7_DRuzbDit5n9a8LyPZ9rboRRuTfIRvH1szaThJNWLloTREmvXBtgDStuC15LDRB051LveqOgkAQkBOnnjO20lOfDvBdh1aDzbYNJhco2apNkuqbhJ1-3RxyYo79w0-f10K3p1QcfPbBXLp5FL-jsgOHaOchrVjQ_OBPyOJkrRj16D849Z2SxckeVjicE.tnq4t3LL1-PH3QI3tTiWo5ON0wkdHyUVLCr8vlHL3vM&dib_tag=se&keywords=gift+cards&qid=1742440391&sprefix=gift%2Caps%2C455&sr=8-1`,
];
